var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"headline"},[_c('div',{staticClass:"headline-title"},[_vm._t("title")],2),(_vm.$slots.addon)?_c('div',{staticClass:"headline-addon"},[_vm._t("addon")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }